import ApplicationController from '../support/application_controller'

export default class extends ApplicationController {

  static targets = [
    'template'
  ]

  static values = {}

  static classes = [
    'hide'
  ]

  initialize() {}

  connect() {
    let html
    if (this.element.shadowRoot) {
      this.shadowRoot = this.element.shadowRoot
      html = this.shadowRoot.querySelector('.shadow-body').innerHTML
      this.shadowRoot.innerHTML = ''
    } else {
      this.shadowRoot = this.element.attachShadow({ mode: 'open' })
      html = this.content
      this.element.innerHTML = ''
    }

    const shadowBody = document.createElement('div')
    shadowBody.classList.add('shadow-body')
    shadowBody.innerHTML = html
    shadowBody.style.containerType = 'inline-size'
    this.shadowRoot.append(shadowBody)

    if (this.hasTemplateTarget) {
      this.templateTarget.remove()
    }

    this.element.classList.remove(this.hideClass)
  }

  // ==== Controllers

  // ==== Actions

  // ==== Getters

  get content() {
    if (this.hasTemplateTarget) {
      return this.templateTarget.innerHTML
    }

    return this.element.innerHTML
  }

  // ==== Setters

  // ==== Private

  // ==== Channels

}
